import React from 'react'
import PropTypes from 'prop-types'
import AuthenticatedImage from 'components/AuthenticatedImage'
import { getSymbolKeyDisplaySrc } from 'utils/timedMatchingGrid'

/**
 * Survey images are private, so server-backed symbols must load through
 * AuthenticatedImage. Local ZIP previews stay on blob: URLs.
 */
const TimedMatchingGridSymbol = ({ entry, alt = '', className, placeholder = '—' }) => {
  const src = getSymbolKeyDisplaySrc(entry)
  const character = typeof entry?.character === 'string' ? entry.character.trim() : ''
  if (!src) {
    if (character) {
      return <span className={className || 'tmg-symbol-character'}>{character}</span>
    }
    return <span className='tmg-placeholder'>{placeholder}</span>
  }
  if (String(src).startsWith('blob:')) {
    return <img src={src} alt={alt} className={className} />
  }
  return <AuthenticatedImage src={src} alt={alt} className={className} />
}

TimedMatchingGridSymbol.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  entry: PropTypes.shape({
    character: PropTypes.string,
    image: PropTypes.string,
    imageSrc: PropTypes.string,
  }),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default TimedMatchingGridSymbol
